<template>
  <v-snackbar v-model="showNotification" :timeout="-1" bottom right :class="['snack', error ? 'has-error' : '']" :multi-line="true" >
    <template v-if="!error">
      <div class="snack-title mb-1">
        <v-icon left color="white">{{ icons.mdiUpdate }}</v-icon>
        <h3 class="subtitle-1 pl-1 pr-6">{{ $t('installPrompt.webappUpdateAvailable') }}</h3>
      </div>
      <div class="action" v-if="!error">
        <v-btn dark text color="white" @click="refreshApp" :loading="loading">
          {{ $t('installPrompt.webappUpdateAvailableButtonText') }}
        </v-btn>
      </div>
    </template>
    <template v-else>
      <div class="snack-error">{{ $t('installPrompt.webappUpdateAvailableFailed') }}</div>
      <v-btn text @click="close()" class="close">
        <v-icon color="white">{{ icons.mdiCloseCircle }}</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  import _ from 'lodash';
  import {mdiUpdate, mdiCloseCircle} from '@mdi/js';

  export default {
    name: 'PwaUpdatedNotification',
    data() {
      return {
        updatedRegistration: false,
        showNotification: false,
        loading: false,
        error: false,
        icons: {mdiUpdate, mdiCloseCircle}
      }
    },
    computed: {
      registration() {
        return this.$store.getters.serviceWorkerUpdated;
      }
    },
    created() {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!this.updatedRegistration) {
          this.updatedRegistration = true;
          setTimeout(() => {
            window.location.reload(true);
          }, 100);
        }
      });
    },
    methods: {
      showRefreshUI() {
        this.showNotification = true;
      },
      refreshApp() {
        this.loading = true;

        if (!_.get(this.registration, 'waiting', false)) {
          this.error = true;
          this.loading = false;
          return;
        }
        this.registration.waiting.postMessage('skipWaiting');
      },
      close() {
        this.showNotification = false;
        setTimeout(() => {
          this.error = false;
        }, 100);
      }
    },
    watch: {
      registration(reg) {
        if (reg) {
          this.showRefreshUI(reg);
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .snack {
    &::v-deep .v-snack__wrapper {
      min-width: 0;
    }
    &::v-deep .v-snack__content {
      flex-direction: column;
      align-items: flex-start;
      min-height: 0;
    }
  }
  .snack-title {
    display: flex;
    align-items: center;
  }
  .action {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  .error {
    width: 100%;
    margin-bottom: 0 !important;
  }
  .snack.has-error {
    &::v-deep .v-snack__wrapper {
      background: var(--v-error-base);
    }
    &::v-deep .v-snack__content {
      white-space: nowrap;
      display: inline;
      .snack-error {
        display: inline;
      }
      .v-btn {
        margin-left: 0;
        padding-right: 0px;
      }
    }
  }
</style>
